<div class="modal-standard__wrapper">
  <div class="modal-standard__inner-wrapper">
    <div class="modal-standard" (sdClickOutside)="onClickOutside()" [style.maxWidth]="options().maxWidth">
      @if (options().title) {
        <div class="modal-standard__header">
          <h3 class="modal-standard__title text-h6-s text-md-h4-s">{{ options().title }}</h3>
        </div>
      }

      <div class="modal-standard__body">
        <ng-content></ng-content>
      </div>
    </div>
    @if (!options().hideCloseButton) {
      <button class="modal-standard__close" (click)="onClose()">
        <sd-icon type="cross" class="icon-size-s icon-size-md-m icon-size-lg-l"></sd-icon>
      </button>
    }
  </div>
</div>
